import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import styles from './sorter-element.module.scss';
import FixFilterDropdown from '../FixFilterDropdown';
import { useProductArea } from '../product-area/context';
import { SortValue } from '../product-area/store/area-filters';

export type SorterElementProps = {
  className?: string;
};

export const SorterElement = ({ className }: SorterElementProps) => {
  const store = useProductArea();
  const group = store.groups['main']!;

  const sorters = group.options.sorters;
  const value = group.sort!;

  const options = sorters.map((item) => ({
    key: item.key,
    name: item.name,
    icon: '',
  }));

  const handleChange = (key: string) => {
    store.changeSort('main', key as SortValue);
  };

  return (
    <div className={classNames(styles.root, className)}>
      <FixFilterDropdown options={options} value={value} onChange={handleChange} />
    </div>
  );
};

export default SorterElement;
